export default "__VITE_ASSET__D0vxjQ9c__"